module.exports = __webpack_public_path__ + "static/media/icon_inspections_grey.ef87028b.svg";